<div class="hero-slider flex flex-col relative"
  [ngStyle]="sectionMaxHeight && sectionMaxHeight !== 'none'
    ? { padding: linePadding, 'max-height': sectionMaxHeight, overflow: 'hidden', 'justify-content': 'center' }
    : { padding: linePadding }">
  <div>
    <vsf-title-box
      [titleInfo]="titleInfo"
      [forComponent]="true">
    </vsf-title-box>
  </div>
  <!-- Fallback image template for SSR -->
  <ng-template #fallbackImage>
    <div class="media-frame relative w-full image-container">
      <ng-container *ngIf="medias?.[0] as firstMedia">
        <ng-container *ngIf="firstMedia.type === 'IMAGE'">
          <img [src]="firstMedia | assetPreview:'full':'webp'"
              [alt]="firstMedia.customFields?.altText ? firstMedia.customFields?.altText : 'Hero Image'"
              style="pointer-events: none;"
              class="object-cover w-full"
              [style.object-position]="firstMedia | focalPoint"
              [width]="firstMedia.width || 1152"
              [height]="firstMedia.height || 648"
              fetchpriority="high"
              loading="eager"
          />
          <div class="absolute inset-0 bg-gray-500" [style.opacity]="shadowOpacity"></div>
        </ng-container>
      </ng-container>
    </div>
  </ng-template>

  <div class="h-full">
    <div *ngIf="medias?.length > 0" class="media-frame h-full">
      <!-- Only show Swiper in browser; fall back to a static image during SSR -->
      <ng-container *ngIf="isBrowser; else fallbackImage">
        <ng-container *ngIf="isSingleVideo; else regularSwiper">
          <div *ngIf="(readyToDisplayVideo$ | async)" class="w-full relative">
            <vsf-vimeo-player
                [source]="medias[0].customFields?.videoUrl || medias[0].source"
                [width]="videoWidth"
                [height]="videoHeight"
                [fullSection]="true"
                [previewImageUrl]="medias[0].imageUrl || medias[0].preview"
                [previewAltText]="medias[0].customFields?.altText ? medias[0].customFields?.altText : 'Hero Video'">
            </vsf-vimeo-player>
            <div class="absolute inset-0 bg-gray-500" [style.opacity]="shadowOpacity" style="pointer-events: none;"></div>
          </div>
        </ng-container>
        <ng-template #regularSwiper>
        <swiper-container
          appSwiper #swiper
          pagination.type="progressbar" pagination-clickable="true"
          centered-slides="true" autoplay-delay="5000" autoplay-disable-on-interaction="false" height="auto"
          rewind="true" lazy="true" autoplay="true" class="flex-grow object-cover custom-pagination h-full" [style.z-index]="1">
          <swiper-slide *ngFor="let media of medias; let i = index">
            <div class="flex justify-center items-center w-full">
              <div *ngIf="media.type === 'IMAGE'" class="w-full h-full relative">
                <img [src]="media | assetPreview:'full':'webp'"
                    [alt]="media.customFields?.altText ? media.customFields?.altText : 'Hero Image'"
                    style="pointer-events: none;"
                    class="object-cover w-full h-full"
                    [style.object-position]="media | focalPoint"
                    [ngClass]="(isMobile && !(heroSection.mobileMedias?.length > 0)) ? 'aspect-[16/9]' : ''"
                    [width]="swiperSlideWidth"
                    [height]="swiperSlideHeight"
                    [attr.loading]="i === 0 ? 'eager' : 'lazy'"
                    [attr.fetchpriority]="i === 0 ? 'high' : 'auto'"
                    decoding="async"
                />
                <div class="absolute inset-0 bg-gray-500" [style.opacity]="shadowOpacity"></div>
              </div>

              <div *ngIf="media.type === 'VIDEO' && media.mimeType === 'video/mp4'" class="w-auto relative">
                <div class="w-auto max-h-none md:max-h-[800px] mx-auto relative">
                  <video style="z-index:1; pointer-events: auto;" [muted]="true" class="object-contain w-full h-full" autoplay playsinline controls>
                    <source
                      [src]="media.source"
                      type="video/mp4"
                    >
                  </video>
                  <div class="absolute inset-0 bg-gray-500" [style.opacity]="shadowOpacity" style="pointer-events: none;"></div>
                </div>
              </div>

              <div *ngIf="media.type === 'VIDEO' && media.mimeType === 'video/vimeo' && swiperSlideWidth > 0" class="w-auto relative">
                <div class="w-auto max-h-none md:max-h-[800px] mx-auto relative">
                  <vsf-vimeo-player
                      [source]="media.customFields?.videoUrl || media.source"
                      [width]="swiperSlideWidth"
                      [height]="swiperSlideHeight"
                      [previewImageUrl]="media.imageUrl || media.preview"
                      [previewAltText]="media.customFields?.altText ? media.customFields?.altText : 'Hero Video'"
                  >
                  </vsf-vimeo-player>
                  <div class="absolute inset-0 bg-gray-500" [style.opacity]="shadowOpacity" style="pointer-events: none;"></div>
                </div>
              </div>
            </div>
          </swiper-slide>
        </swiper-container>
        </ng-template>
      </ng-container>
    </div>

    <!-- Text & Button Layouts -->
    <div
      *ngIf="layoutType === 'left-text-full-media'"
      style="z-index: 5; pointer-events: none;"
      class="absolute inset-0 flex flex-col items-start justify-between top-1/2 transform -translate-y-1/2 left-0"
    >
      <div class="px-2 md:px-8 w-full" [ngClass]="{'max-w-6xl mx-auto': pageFullWidth}">
      <div class="hero-text-left">
        <h1 *ngIf="isPageHeading && h1StyleMode === 'sr-only'" class="sr-only">{{ title }}</h1>
        <h1 *ngIf="isPageHeading && h1StyleMode !== 'sr-only'" [ngStyle]="{'color': textColor, 'font-size': titleFontSize}" class="hero-title whitespace-nowrap" [innerHTML]="title | safeHtml"></h1>
        <div *ngIf="!isPageHeading || h1StyleMode === 'sr-only'" [ngStyle]="{'color': textColor, 'font-size': titleFontSize}" class="hero-title whitespace-nowrap" [innerHTML]="title | safeHtml"></div>
        <div [ngStyle]="getSubtitleStyles()" class="hero-subtitle mt-2" [innerHTML]="subtitle | safeHtml"></div>
        <div *ngIf="button?.enabled && (isMobile ? buttonPositionMobile : buttonPosition) === 'below-text'"
          class="button-container flex"
          [ngClass]="{
            'w-full justify-start': (isMobile ? buttonAlignmentMobile : buttonAlignment) === 'left',
            'w-full justify-end': (isMobile ? buttonAlignmentMobile : buttonAlignment) === 'right'
          }"
        >
          <button (click)="buttonClick($event); $event.stopPropagation()"
              class="shop-button mt-12 md:mt-20 justify-center rounded-lg focus:outline-none"
              [class.mx-auto]="(isMobile ? buttonAlignmentMobile : buttonAlignment) === 'center'"
              style="pointer-events: auto;"
              [ngStyle]="buttonStyles"
              [ngClass]="{ 'opacity-80': inFlight }"
              [disabled]="inFlight">
              <div class="flex-container justify-center">
                <p>{{button.text}}</p>
                <fa-icon [icon]="['fas', 'caret-right']" class="ml-2 color-black icon-size"></fa-icon>
              </div>
          </button>
        </div>
      </div>
      </div>
    </div>

    <div
      *ngIf="layoutType === 'middle-text-full-media'"
      style="z-index: 5; pointer-events: none;"
      class="absolute inset-0 flex flex-col items-center justify-center"
    >
      <div class="px-2 md:px-8 w-full" [ngClass]="{'max-w-6xl mx-auto': pageFullWidth}">
      <div class="hero-text-middle text-center">
        <h1 *ngIf="isPageHeading && h1StyleMode === 'sr-only'" class="sr-only">{{ title }}</h1>
        <h1 *ngIf="isPageHeading && h1StyleMode !== 'sr-only'" [ngStyle]="{'color': textColor, 'font-size': titleFontSize}" class="hero-title" [innerHTML]="title | safeHtml"></h1>
        <div *ngIf="!isPageHeading || h1StyleMode === 'sr-only'" [ngStyle]="{'color': textColor, 'font-size': titleFontSize}" class="hero-title" [innerHTML]="title | safeHtml"></div>
        <div [ngStyle]="getSubtitleStyles()" class="hero-subtitle mt-2" [innerHTML]="subtitle | safeHtml"></div>
        <div *ngIf="button?.enabled && (isMobile ? buttonPositionMobile : buttonPosition) === 'below-text'"
          class="button-container flex mt-4 md:mt-20"
          [ngClass]="{
            'w-full justify-start': (isMobile ? buttonAlignmentMobile : buttonAlignment) === 'left',
            'w-full justify-end': (isMobile ? buttonAlignmentMobile : buttonAlignment) === 'right'
          }"
        >
          <button (click)="buttonClick($event); $event.stopPropagation()"
              class="shop-button justify-center rounded-lg focus:outline-none"
              [class.mx-auto]="(isMobile ? buttonAlignmentMobile : buttonAlignment) === 'center'"
              style="pointer-events: auto;"
              [ngStyle]="buttonStyles"
              [ngClass]="{ 'opacity-80': inFlight }"
              [disabled]="inFlight">
              <div class="flex-container justify-center">
                <p>{{button.text}}</p>
                <fa-icon [icon]="['fas', 'caret-right']" class="ml-2 color-black icon-size"></fa-icon>
              </div>
          </button>
        </div>
      </div>
      </div>
    </div>

    <div
      *ngIf="layoutType === 'right-text-full-media'"
      style="z-index: 5; pointer-events: none;"
      class="absolute inset-0 flex flex-col items-end justify-between top-1/2 transform -translate-y-1/2 right-0"
    >
      <div class="px-2 md:px-8 w-full flex flex-col items-end" [ngClass]="{'max-w-6xl mx-auto': pageFullWidth}">
      <div class="hero-text-right">
        <h1 *ngIf="isPageHeading && h1StyleMode === 'sr-only'" class="sr-only">{{ title }}</h1>
        <h1 *ngIf="isPageHeading && h1StyleMode !== 'sr-only'" [ngStyle]="{'color': textColor, 'font-size': titleFontSize}" class="hero-title whitespace-nowrap" [innerHTML]="title | safeHtml"></h1>
        <div *ngIf="!isPageHeading || h1StyleMode === 'sr-only'" [ngStyle]="{'color': textColor, 'font-size': titleFontSize}" class="hero-title whitespace-nowrap" [innerHTML]="title | safeHtml"></div>
        <div [ngStyle]="getSubtitleStyles()" class="hero-subtitle mt-2" [innerHTML]="subtitle | safeHtml"></div>
        <div *ngIf="button?.enabled && (isMobile ? buttonPositionMobile : buttonPosition) === 'below-text'"
          class="button-container flex"
          [ngClass]="{
            'w-full justify-start': (isMobile ? buttonAlignmentMobile : buttonAlignment) === 'left',
            'w-full justify-end': (isMobile ? buttonAlignmentMobile : buttonAlignment) === 'right'
          }"
        >
          <button (click)="buttonClick($event); $event.stopPropagation()"
              class="shop-button mt-4 md:mt-20 justify-center rounded-lg focus:outline-none"
              [class.mx-auto]="(isMobile ? buttonAlignmentMobile : buttonAlignment) === 'center'"
              style="pointer-events: auto;"
              [ngStyle]="buttonStyles"
              [ngClass]="{ 'opacity-80': inFlight }"
              [disabled]="inFlight">
              <div class="flex-container justify-center">
                <p>{{button.text}}</p>
                <fa-icon [icon]="['fas', 'caret-right']" class="ml-2 color-black icon-size"></fa-icon>
              </div>
          </button>
        </div>
      </div>
      </div>
    </div>

    <div
      *ngIf="layoutType === 'custom-text-location-full-media'"
      style="z-index: 5; pointer-events: none;"
      class="absolute inset-0"
    >
      <div class="h-full"
           [class.max-w-6xl]="pageFullWidth"
           [class.mx-auto]="pageFullWidth"
           [class.relative]="pageFullWidth">
      <div class="flex flex-col" [ngStyle]="getTextContainerStyles()" [ngClass]="textAlignmentClasses">
        <h1 *ngIf="isPageHeading && h1StyleMode === 'sr-only'" class="sr-only">{{ title }}</h1>
        <h1 *ngIf="isPageHeading && h1StyleMode !== 'sr-only'"
          [ngStyle]="{ 'color': textColor, 'font-size': titleFontSize }"
          class="hero-title"
          [innerHTML]="title | safeHtml">
        </h1>
        <div *ngIf="!isPageHeading || h1StyleMode === 'sr-only'"
          [ngStyle]="{ 'color': textColor, 'font-size': titleFontSize }"
          class="hero-title"
          [innerHTML]="title | safeHtml">
        </div>

        <div
          [ngStyle]="getSubtitleStyles()"
          class="hero-subtitle mt-2"
          [innerHTML]="subtitle | safeHtml">
        </div>

        <div
          *ngIf="button?.enabled && (isMobile ? buttonPositionMobile : buttonPosition) === 'below-text'"
          class="button-container flex mt-4"
        >
          <button
            (click)="buttonClick($event); $event.stopPropagation()"
            class="shop-button justify-center rounded-lg focus:outline-none"
            [class.mx-auto]="(isMobile ? buttonAlignmentMobile : buttonAlignment) === 'center'"
            style="pointer-events: auto;"
            [ngStyle]="buttonStyles"
            [ngClass]="{ 'opacity-80': inFlight }"
            [disabled]="inFlight">
            <div class="flex-container justify-center">
              <p>{{ button.text }}</p>
              <fa-icon [icon]="['fas', 'caret-right']" class="ml-2 color-black icon-size"></fa-icon>
            </div>
          </button>
        </div>
      </div>
      </div>
    </div>

    <ng-container *ngIf="button?.enabled && (isMobile ? buttonPositionMobile : buttonPosition) === 'custom'">
      <div [class.absolute]="pageFullWidth"
           [class.inset-0]="pageFullWidth"
           [class.max-w-6xl]="pageFullWidth"
           [class.mx-auto]="pageFullWidth">
      <div class="button-container" [ngStyle]="getButtonStyles()">
        <button
          (click)="buttonClick($event); $event.stopPropagation()"
          class="shop-button justify-center rounded-lg focus:outline-none"
          [ngStyle]="buttonStyles"
          [ngClass]="{ 'opacity-80': inFlight }"
          [disabled]="inFlight"
        >
          <div class="flex-container justify-center">
            <p>{{ button.text }}</p>
            <fa-icon [icon]="['fas', 'caret-right']" class="ml-2 icon-size"></fa-icon>
          </div>
        </button>
      </div>
      </div>
    </ng-container>
  </div>
</div>
